import styled from "styled-components"

const Title = styled.h2`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`

export { Title }
